<template>
  <div class="panel-in-tab">
    <!-- 顶部标签页 -->
    <div class="tab-header">
      <el-tabs v-model="activeTopTab" @tab-click="handleTopTabClick" class="top-tabs">
        <el-tab-pane label="价格相关" name="price"></el-tab-pane>
        <el-tab-pane label="设计图" name="design"></el-tab-pane>
        <el-tab-pane label="其他信息" name="other"></el-tab-pane>
        <el-tab-pane label="通栏图" name="banner"></el-tab-pane>
        <el-tab-pane label="SKU推广名称" name="skuPromotion"></el-tab-pane>
      </el-tabs>
    </div>
    
    <!-- 引入内容组件 -->
    <price-content v-if="activeTopTab === 'price'" @getNumber="getNumber" />
    <design-content v-else-if="activeTopTab === 'design'" @getNumber="getNumber" />
    <other-content v-else-if="activeTopTab === 'other'" @getNumber="getNumber" />
    <banner-content v-else-if="activeTopTab === 'banner'" @getNumber="getNumber" />
    <other-content
      v-else-if="activeTopTab === 'skuPromotion'"
      :adjust-content="'SKU推广名称'"
      :hide-adjust-content-filter="true"
      @getNumber="getNumber"
    />
  </div>
</template>

<script>
import PriceContent from './components/PriceContent.vue';
import DesignContent from './components/DesignContent.vue';
import OtherContent from './components/OtherContent.vue';
import BannerContent from './components/BannerContent.vue';

export default {
  name: 'ToBeProcessed',
  components: {
    PriceContent, 
    DesignContent,
    OtherContent,
    BannerContent
  },
  data() {
    return {
      activeTopTab: 'price',
    };
  },
  methods: {
    handleTopTabClick() {
      // 处理顶部标签页切换
    },
    getNumber() {
      // 更新数量
      this.$emit('getNumber');
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel-in-tab {
  height: 100%;
}

.tab-header {
  margin-bottom: 10px;
}

.top-tabs {
  >>> .el-tabs__header {
    margin-bottom: 10px;
  }
}
</style>
